import React, { useEffect, Fragment } from "react";
import { Redirect }    from "react-router-dom"
import HeaderExtended   from "../../components/layout/HeaderExtended";
import Miniaturas from "../../components/Miniaturas";
import ROUTES from "../../utils/routes";

/*import { 
    getCategoriasR as getCats,
    getArticulosR as getArts,
    jsonDeserialize
}   from "../../API/request";*/
import Loading from "../../components/Loading";

import { useSelector }              from "react-redux";
import BtnSubir from "../../components/BtnSubir";


const Results = () => {

    const [showLoading, setShowLoading] = React.useState(true);
    const showPrice = process.env.REACT_APP_SHOW_PRICE  === 'false' ? false : true;

    let busquedaObj = useSelector((state) => state.search);

    useEffect(() => {
        document.title = "Results";
        window.scrollTo(0, 0)
        setShowLoading(false);
    }, [setShowLoading]);

    return (
        busquedaObj.categorias === null 
        ?   <Redirect to={ROUTES.HOME} />
        :   <Fragment>
                {
                    showLoading
                    ?   <Loading/>
                    :   <>
                            <HeaderExtended
                                category=""
                                menuType={false}
                                listado={busquedaObj.categorias}
                                actual={"Resultados"}
                            />
                            <div className="content secondary">
                                {
                                    busquedaObj.listResultsPage.length > 0 &&
                                        <Miniaturas
                                            title="Resultados"
                                            listArticulos={busquedaObj.listResultsPage}
                                            showPrice={showPrice}
                                        />
                                }
                            </div>
                            <BtnSubir />
                        </>
                }
            </Fragment>
    );
};

export default Results;
